import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { ExpenditureType, Props } from "./types";
import styles from "./styles.scss";

function ExpenditureTypeSelector({ value, disabled, submit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.row}>
      <p className={styles.label}>{t("taskRetrieval.expenditureType.label")}</p>
      <SelectList
        rootClassName={styles.root}
        listClassName={styles.listRoot}
        isDisabled={disabled}
      >
        {({ isOpen, hide }) => ({
          input: (
            <div
              className={classNames(styles.input, { [styles.opened]: isOpen })}
            >
              <p>
                {value
                  ? t(`taskRetrieval.expenditureType.${value.toLowerCase()}`)
                  : "-"}
              </p>
              <ToggleArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              <div
                className={classNames(styles.option, {
                  [styles.selected]: !value,
                })}
                onClick={() => {
                  submit(null);
                  hide();
                }}
              >
                <p>{t("taskRetrieval.expenditureType.none")}</p>
              </div>
              {Object.values(ExpenditureType).map((option) => (
                <div
                  key={option}
                  className={classNames(styles.option, {
                    [styles.selected]: value === option,
                  })}
                  onClick={() => {
                    submit(value === option ? null : option);
                    hide();
                  }}
                >
                  <p>
                    {t(`taskRetrieval.expenditureType.${option.toLowerCase()}`)}
                  </p>
                </div>
              ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { ExpenditureTypeSelector };
